import { jsx as i, jsxs as v } from "react/jsx-runtime";
import a from "classnames";
import e from "./index.es5594.js";
import { DETAIL_TO_PROPERTIES as C } from "./index.es5595.js";
import { useIsTextOverflowing as h } from "@placer-ui/hooks";
import { DetailValue as N } from "./index.es5596.js";
import { BodyText as x } from "./index.es505.js";
import { SimpleTooltip as T } from "./index.es127.js";
const D = ({ field: s, label: t, value: r, testId: o, isWrapping: l }) => {
  const n = C[s], { iconComponent: m, type: d } = n, { textElmRef: c, isOverflowing: p } = h(), f = a(e.detailContainer, {
    [e.isWrapping]: l
  });
  return /* @__PURE__ */ i("div", { className: e.detailRowContainer, "data-testid": `${o}-detail-${t}`, children: /* @__PURE__ */ v("div", { className: f, children: [
    /* @__PURE__ */ i("div", { className: e.iconContainer, children: m }),
    /* @__PURE__ */ i("div", { className: e.labelContainer, children: /* @__PURE__ */ i(
      x,
      {
        isEllipsis: !0,
        size: "small",
        variant: "regular",
        testId: `${o}-detail-${t}-label`,
        children: t
      }
    ) }),
    /* @__PURE__ */ i(T, { title: r, isActive: p, children: /* @__PURE__ */ i("div", { className: a(e.valueContainer), children: /* @__PURE__ */ i(
      N,
      {
        value: r,
        type: d,
        ref: c,
        testId: `${o}-detail-${r}-value`
      }
    ) }) })
  ] }) });
};
export {
  D as DetailRow
};
//# sourceMappingURL=index.es807.js.map
